import { render } from "./RouteRegionMap.vue?vue&type=template&id=52459cbb&scoped=true"
import script from "./RouteRegionMap.vue?vue&type=script&lang=js"
export * from "./RouteRegionMap.vue?vue&type=script&lang=js"

import "./RouteRegionMap.vue?vue&type=style&index=0&id=52459cbb&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/solution/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52459cbb"]])

export default __exports__